import React from 'react'
import withAuthenticateLayout from 'containers/hoc/withAuthenticateLayout'
import FakeStatisticsView from 'components/views/statistics/fakeStatisticsView'

const FakeStatistics: React.FC = () => {
    return <FakeStatisticsView />
}

export default withAuthenticateLayout(FakeStatistics)
